import { Link } from "wouter";
import { SEOHead } from "@/components/seo/SEOHead";

export default function NotFound() {
  return (
    <>
      <SEOHead title="Seite nicht gefunden | YADE HOME" description="Diese Seite existiert nicht." noIndex />
      <main className="yh flex min-h-[70vh] w-full items-center bg-white">
        <div className="mx-auto w-full max-w-[1280px] px-[var(--yh-gutter)] py-32">
          <p className="text-[15px] font-medium text-yh-muted">Fehler 404</p>
          <h1 className="mt-3 text-[40px] font-semibold leading-[1.05] tracking-[-0.03em] text-yh-ink md:text-[56px]">
            Seite nicht gefunden.
          </h1>
          <p className="mt-5 max-w-xl text-xl leading-snug text-yh-muted">
            Die Seite wurde verschoben oder existiert nicht mehr.
          </p>
          <div className="mt-10 flex flex-wrap gap-3">
            <Link
              href="/"
              className="rounded-full bg-yh-ink px-6 py-3 text-[15px] font-medium text-white transition-colors hover:bg-black"
            >
              Zur Startseite
            </Link>
            <Link
              href="/immobilien"
              className="rounded-full border border-yh-line px-6 py-3 text-[15px] font-medium text-yh-ink transition-colors hover:border-yh-ink"
            >
              Immobilien ansehen
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
